import PropTypes from 'prop-types';
import styled from 'styled-components';

import { HeadingParagraph } from './Heading';
import {
  ParagraphNormalSub,
  ParagraphRegular,
  ParagraphRegularSub,
} from './Paragraph';
import Divider from './Divider';
import ChevronRight from './Icons/ChevronRight';
import themeColors from '../assets/styles/themeColors';

const FullContainer = styled.div`
  align-items: center;
  display: grid;
  gap: 10px;
  grid-template-columns: ${({ hasImage }) =>
    hasImage ? '74px 1fr 25px' : '1fr 25px'};
  margin: 5px 0;
  padding: 10px 25px;
  cursor: pointer;
  background-color: ${({ active }) =>
    active ? themeColors.colorBackgroundSecondaryLight : 'transparent'};

  &:hover {
    background-color: ${themeColors.colorBackgroundSecondary};
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Spacer = styled.div`
  margin-top: 4px;
`;

const Image = styled.img`
  width: 74px;
  height: 74px;
  object-fit: contain;
`;

const SelectionContainer = ({
  title,
  subtitle,
  description,
  showDivider,
  onlyTitle,
  titleWeight,
  onClick,
  active,
  paragraphTitle,
  imageUrl,
  imageAlt,
  showChevron,
  Icon,
  showIcon,
  children,
}) => (
  <>
    <FullContainer onClick={onClick} active={active} hasImage={imageUrl}>
      {!!imageUrl && <Image src={imageUrl} alt={imageAlt} />}
      <Container>
        {children || onlyTitle ? (
          <>
            <ParagraphRegular weight={titleWeight}>{title}</ParagraphRegular>
            {children}
          </>
        ) : (
          <>
            {paragraphTitle ? (
              <ParagraphRegular weight={600}>{title}</ParagraphRegular>
            ) : (
              <HeadingParagraph isNormal>{title}</HeadingParagraph>
            )}
            {!!subtitle && (
              <Spacer>
                <ParagraphNormalSub
                  color={paragraphTitle ? themeColors.colorTextSecondary : null}
                >
                  {subtitle}
                </ParagraphNormalSub>
              </Spacer>
            )}
            {!!description && (
              <Spacer>
                <ParagraphRegularSub>{description}</ParagraphRegularSub>
              </Spacer>
            )}
          </>
        )}
      </Container>
      {showChevron && !Icon && <ChevronRight />}
      {!!Icon && showIcon && <Icon />}
      {!showIcon && <div />}
    </FullContainer>
    {showDivider && <Divider horizontal height="10px" />}
  </>
);

SelectionContainer.propTypes = {
  title: PropTypes.string.isRequired,
  titleWeight: PropTypes.number,
  description: PropTypes.string,
  subtitle: PropTypes.string,
  showDivider: PropTypes.bool,
  onClick: PropTypes.func,
  onlyTitle: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  paragraphTitle: PropTypes.bool,
  active: PropTypes.bool,
  imageUrl: PropTypes.string,
  imageAlt: PropTypes.string,
  showChevron: PropTypes.bool,
  Icon: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string,
    PropTypes.shape({ render: PropTypes.func.isRequired }),
  ]),
  showIcon: PropTypes.bool,
};

SelectionContainer.defaultProps = {
  showDivider: true,
  onClick: Function.prototype,
  onlyTitle: false,
  titleWeight: 600,
  active: false,
  paragraphTitle: false,
  showChevron: true,
  showIcon: true,
};

export default SelectionContainer;
